// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.MobileAppsList__container-a3a621 {
  list-style-type: none;
  display: flex;
  justify-content: center;
  padding: 0;
  gap: 16px;
  margin: 0;
}

.MobileAppsList__app-item-b5894b {
  display: block;
}

/* .app-app-store не работает, видимо не предусмотрена такая конструкция */
.MobileAppsList__app-appStore-ff6e4b .MobileAppsList__app-icon-dbf4df {
  fill: var(--base-120);
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/MobileAppsList/MobileAppsList.styles.m.css"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA,0EAAA;AACA;EACE,qBAAA;AAEF","sourcesContent":[".container {\n  list-style-type: none;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  gap: 16px;\n  margin: 0;\n}\n\n.app-item {\n  display: block;\n}\n\n/* .app-app-store не работает, видимо не предусмотрена такая конструкция */\n.app-appStore .app-icon {\n  fill: var(--base-120);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MobileAppsList__container-a3a621`,
	"app-item": `MobileAppsList__app-item-b5894b`,
	"appItem": `MobileAppsList__app-item-b5894b`,
	"app-appStore": `MobileAppsList__app-appStore-ff6e4b`,
	"appAppStore": `MobileAppsList__app-appStore-ff6e4b`,
	"app-icon": `MobileAppsList__app-icon-dbf4df`,
	"appIcon": `MobileAppsList__app-icon-dbf4df`
};
module.exports = ___CSS_LOADER_EXPORT___;
